<div class="row">

  <div class="col-md-12">
    <nb-card>
      <nb-card-header>
        <nav class="navbar navigation">
          <h2><nb-icon icon="file-text-outline"></nb-icon> Entidad personalizada - {{currentEntity.name}}</h2>
          <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
          </button>

        </nav>
      </nb-card-header>
      <nb-card-body>

        <nb-tabset>
          <nb-tab *ngIf="userRole.includes('superadmin')"
          tabTitle="Configuraci&oacute;n" nbSpinnerStatus="danger" nbSpinnerSize="large"
           nbSpinnerMessage="Guardando Entidad..." [nbSpinner]="loading">

              <div class="row mb-5">
              <div class="form-group col-sm-4">
                <label for="entityname" class="label col-12">Nombre</label>
                <input fullWidth type="text" nbInput id="entityname" name="entityname" [(ngModel)]="currentEntity.name" />
              </div>
              <div class="form-group col-sm-3">
                <label for="TiposEntidad" class="label col-12">Tipo de entidad</label>
                <ng-multiselect-dropdown
                    placeholder="Tipo de entidad"
                    [settings]="dropdownSettingsTipo"
                    [data]="tiposEntidadArray"
                    [(ngModel)]="selectedTiposEntidad">
                  </ng-multiselect-dropdown>
              </div>
              <div class="form-group col-sm-2">
                <label for="history" class="label col-12">Permitir histórico</label>

                <nb-checkbox  fullWidth id="history" name="history" [(ngModel)]="currentEntity.history" ng-checked="currentEntity.history == true">Histórico</nb-checkbox>

              </div>
              <div class="form-group col-sm-2">
                <label for="geoespacial" class="label col-12">Entidad geoespacial</label>

                <nb-checkbox [disabled]="currentEntity.id" fullWidth id="geoespacial" name="geoespacial" [(ngModel)]="currentEntity.geospatial" ng-checked="currentEntity.geospatial == true">Entidad geoespacial</nb-checkbox>

              </div>

              <div class="form-group col-sm-3">
                <label for="relacionesSimples" class="label col-12">Relaciones simples</label>


                <ng-multiselect-dropdown
                    placeholder="Entidades"
                    [settings]="dropdownSettings"
                    [data]="relacionesSimplesArray"
                    [(ngModel)]="selectedRelacionesSimples">
                  </ng-multiselect-dropdown>

              </div>
              <div class="form-group col-sm-3" [hidden]="!currentEntity.geospatial">
                <label for="relacionesGeospaciales" class="label col-12">Relaciones geoespaciales</label>

                <ng-multiselect-dropdown
                placeholder="Entidades"
                [settings]="dropdownSettings"
                [data]="relacionesGeospacialesArray"
                [(ngModel)]="selectedRelacionesGeospaciales">
              </ng-multiselect-dropdown>
              </div>
            </div>

            <h6>Atributos de entidad</h6>
            <div class="row">
              <div class="col-sm-12">
            <ng2-smart-table class="attributes-table" [settings]="entitiesSettings" [source]="source" (createConfirm)="confirmarFila($event)" (editConfirm)="confirmaSaveAttr($event)" (deleteConfirm)="confirmaDelAttr($event)">
            </ng2-smart-table>
              </div>
            </div>
            <div class="row"><br/><br/></div>
            <h6>Relaciones por atributo</h6>
            <ng2-smart-table [settings]="attributeJoinsSettings" [source]="attributeJoinsSource" (createConfirm)="confirmarNuevaRelacion($event)"  (editConfirm)="confirmarRelacion($event)">
            </ng2-smart-table>

            <div class="row mt-4">
              <button nbButton status="primary" class="col-7" (click)="guardarEntitdad()">Guardar</button>
              <button *ngIf="currentEntity.id" nbButton status="danger" class="col-4 offset-1" (click)="eliminarEntidad(deletedialog)">Eliminar</button>
            </div>
          </nb-tab>

          <nb-tab *ngIf="idCustomEntity != '0'" tabTitle="Elementos" [active]="!userRole.includes('superadmin')" >
            <div class="container-elements" #celements [hidden]="editElements">
              <div *ngFor="let r of reset">
                <ng2-smart-table [settings]="elementsSettings" (custom)="customActionEvent($event)" [source]="elementSource" (create)="crearElemento($event)" (edit)="editarElemento($event)" (delete)="deleteElemento($event)">
                </ng2-smart-table>
              </div>

            </div>
            <div class="col-12 container-edit-elements" *ngIf="editElements">
              <nb-card nbSpinnerStatus="info" nbSpinnerSize="large"
              nbSpinnerMessage="Cargando elemento..." [nbSpinner]="loadingElement">
                <nb-card-header><button nbButton status="primary" (click)="mostrarElementos()"><nb-icon icon="arrow-back"></nb-icon></button> Editando elemento {{currentElement.name}}</nb-card-header>
                <nb-card-body>
                  <form autocomplete="off">
                  <div class="container-element row">
                    <div class="container-inputs col-4">


                      <div *ngFor="let item of elementsSettings.columns | keyvalue">
                        <div class="form-group" *ngIf="item.key == 'name'">
                          <label for="entityname" class="label col-12">{{elementsSettings.columns[item.key].title}}</label>
                          <input #nameField fullWidth type="text" nbInput [(ngModel)]="currentElement.name" name="attributeName" />
                        </div>


                      </div>
                      <div *ngFor="let item of elementsSettings.columns | keyvalue">
                        <div class="form-group" *ngIf="elementsSettings.columns[item.key].type == 'text' && item.key !== 'name'">
                          <label class="label col-12">{{elementsSettings.columns[item.key].title}}</label>


                         <input
                              #entradaAtributo
                              [(ngModel)]="currentElement[item.key]"
                              fullWidth
                              nbInput
                              type="text"
                              [name]="elementsSettings.columns[item.key].title"
                              [nbAutocomplete]="atributovalor"/>
                            <nb-autocomplete #atributovalor activeFirst="false" >
                              <nb-option *ngFor="let option of elementsSettings.columns[item.key].listValues" [value]="option" >
                                {{ option }}
                              </nb-option>
                            </nb-autocomplete>

                          </div>
                          <div class="form-group" *ngIf="elementsSettings.columns[item.key].type == 'number'">
                            <label class="label col-12">{{elementsSettings.columns[item.key].title}}</label>
                            <input #entradaNumber fullWidth type="number" nbInput [(ngModel)]="currentElement[item.key]" [name]="item.key"/>
                          </div>
                          <div class="form-group" *ngIf="elementsSettings.columns[item.key].type == 'date'">
                            <label class="label col-12">{{elementsSettings.columns[item.key].title}}</label>
                            <ngx-date-field [(datevalue)]="currentElement[item.key]" dateformat="yyyy-MM-dd"></ngx-date-field>
                          </div>
                        </div>


                    </div>
                    <div class="col-8" *ngIf="currentEntity.geospatial">
                      <div [nbSpinner]="loadingLocalidad" nbSpinnerStatus="danger" nbSpinnerSize="large" nbSpinnerMessage="Buscando localidad...">

                        <div class="row" *ngIf="currentElement.geometry == undefined || currentElement.geometry == null">
                          <div class="col-12">
                            <div class="form-group">

                              <input type="text" nbInput fullWidth id="busqueda" name="busqueda" placeholder="Localidad, Region, Pais" [(ngModel)]="busquedaLocalidad" (keyup.enter)="buscarLocalidad()" />
                            </div>
                          </div>
                        </div>
                        <div class="row">

                          <div #mapa class="map-container container-geometria col-12" [attr.id]="config.target" *ngIf="mapavisible">
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                  </form>
                </nb-card-body>
                <nb-card-footer>
                  <div class="row">
                    <div class="col-3 text-left">

                      <button nbButton status="primary" (click)="mostrarElementos()"><nb-icon icon="arrow-back"></nb-icon>Volver</button>
                    </div>
                    <div class="col-3 text-right">
                      <button *ngIf="currentElement.archivedAt" nbButton status="success" (click)="desarchivarElemento()"><nb-icon icon="save"></nb-icon>Desarchivar</button>
                      <button *ngIf="currentElement.id && currentElement.archivedAt == null" nbButton status="danger" (click)="archivarElemento()"><nb-icon icon="save"></nb-icon>Archivar</button>

                    </div>
                    <div class="col-3 text-right">
                      <button *ngIf="currentElement.disabledAt" nbButton status="success" (click)="restaurarElemento()"><nb-icon icon="save"></nb-icon>Restaurar</button>
                      <button *ngIf="currentElement.id && currentElement.disabledAt == null"nbButton status="danger" (click)="eliminarElemento(deleteelementdialog)"><nb-icon icon="save"></nb-icon>Eliminar</button>

                    </div>
                    <div class="col-3 text-right">
                      <button nbButton status="primary" [disabled]="savingElement" (click)="updateElemento()"><nb-icon icon="save"></nb-icon>Guardar</button>

                    </div>

                  </div>
                </nb-card-footer>
              </nb-card>
            </div>
          </nb-tab>
          <nb-tab *ngIf="currentEntity.history" tabTitle="Históricos">
            <ngx-elements-history #historyElements></ngx-elements-history>
          </nb-tab>

          <nb-tab *ngIf="idCustomEntity != '0' && userRole.includes('manager')" tabTitle="Archivados" >
            <ngx-elements-archived #archivedElements></ngx-elements-archived>

          </nb-tab>

          <nb-tab *ngIf="idCustomEntity != '0' && userRole.includes('manager')" tabTitle="Eliminados" >
            <ngx-elements-deleted #deletedElements></ngx-elements-deleted>

          </nb-tab>

        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ng-template #deletedialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar entidad</nb-card-header>
    <nb-card-body>Confirmas que quieres eliminar la entidad <b>{{ data }}</b></nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="danger" (click)="confirmarEliminar(data);ref.close()">Eliminar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #deleteelementdialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar elemento</nb-card-header>
    <nb-card-body>Confirmas que quieres eliminar el elemento <b>{{ data.name }}</b></nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="danger" (click)="confirmarEliminarElemento();ref.close()">Eliminar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
